// companyStorage.ts
export function getCompanyId(): string | null {
    return localStorage.getItem("companyId");
}

export function setCompanyId(id: string | null) {
    if (id && id.trim() !== "") {
        localStorage.setItem("companyId", id);
    } else {
        localStorage.removeItem("companyId");
    }
}

export function getSelectedCompanyId(): string | null {
    return localStorage.getItem("selectedCompanyId");
}

export function setSelectedCompanyId(id: string | null) {
    if (id && id.trim() !== "") {
        localStorage.setItem("selectedCompanyId", id);
    } else {
        localStorage.removeItem("selectedCompanyId");
    }
}

export function clearCompanyContext() {
    localStorage.removeItem("companyId");
    localStorage.removeItem("selectedCompanyId");
}
